import { useEffect, useState } from "react";
import { Ticket, Heart, Crown } from "lucide-react";
import { EVENT_CONFIG } from "@/config/eventConfig";
import { useDonate } from "./shared";

const StickyCTA = () => {
  const { openDonate } = useDonate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.7);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`fixed bottom-0 inset-x-0 z-[60] md:hidden glass border-t border-champagne/20 px-3 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] transition-transform duration-500 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="grid grid-cols-3 gap-2">
        <a
          data-testid="mobile-sticky-buy-tickets-button"
          href={EVENT_CONFIG.urls.buyTickets}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-1.5 py-3.5 rounded-full bg-gradient-to-r from-gold via-champagne to-gold text-ink text-[11px] uppercase tracking-[0.12em] font-bold"
        >
          <Ticket size={13} /> Tickets
        </a>
        <button
          data-testid="mobile-sticky-give-button"
          onClick={() => openDonate(250)}
          className="inline-flex items-center justify-center gap-1.5 py-3.5 rounded-full bg-wine border border-winelight text-ivory text-[11px] uppercase tracking-[0.12em] font-bold"
        >
          <Heart size={13} /> Give $250
        </button>
        <a
          data-testid="mobile-sticky-sponsor-button"
          href="#sponsor"
          className="inline-flex items-center justify-center gap-1.5 py-3.5 rounded-full border border-champagne/50 text-champagne text-[11px] uppercase tracking-[0.12em] font-bold"
        >
          <Crown size={13} /> Sponsor
        </a>
      </div>
    </div>
  );
};

export default StickyCTA;
